import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/JobsPage.head';
import { JobsPage } from '@pages/JobsPage';

export const Route = createFileRoute('/jobs/')({
  component: JobsPage,
  head: () => head,
});
